import { ThemeOptions } from "@mui/material";

/**
 * Lloyds designs use noticeably rounder cards/inputs/list rows than the
 * base theme's 5px radius (search box, bank rows, confirm-payment buttons).
 */
const shape: ThemeOptions["shape"] = { borderRadius: 10 };

export default shape;
